import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Energy_Release_Component.png'
import { energyReleaseWfasInfo } from '@/constants/layers/wfasLayerInfo'

export const energyReleaseNA: LayerRaw = {
  id: 'EnergyRelease',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Energy Release Component (ERC)',
    'pt-BR': 'Componente de Liberação de Energia (ERC)',
    'es-ES': 'Componente de Liberación de Energía (ERC)',
    'fr-FR': "Composante de libération d'énergie (ERC)"
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info: energyReleaseWfasInfo },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'wfas:ERC_Percentiles',
      visible: true,
      legend: {
        title: {
          'en-US': 'Energy Release Component (ERC)',
          'pt-BR': 'Componente de Liberação de Energia (ERC)',
          'es-ES': 'Componente de Liberación de Energía (ERC)',
          'fr-FR': "Composante de libération d'énergie (ERC)"
        },
        items: [
          {
            text: {
              'en-US': 'Less than 60%',
              'es-ES': 'Menos de 60%',
              'pt-BR': 'Menos de 60%',
              'fr-FR': 'Moins de 60%'
            },
            color: '#1a9641',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '60% to 79%',
              'es-ES': '60% a 79%',
              'pt-BR': '60% a 79%',
              'fr-FR': '60% à 79%'
            },
            color: '#a6d96a',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '80% to 89%',
              'es-ES': '80% a 89%',
              'pt-BR': '80% a 89%',
              'fr-FR': '80% à 89%'
            },
            color: '#ffffbf',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '90% to 96%',
              'es-ES': '90% a 96%',
              'pt-BR': '90% a 96%',
              'fr-FR': '90% à 96%'
            },
            color: '#fdae61',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': '97% to 99%',
              'es-ES': '97% a 99%',
              'pt-BR': '97% a 99%',
              'fr-FR': '97% à 99%'
            },
            color: '#d7191c',
            icon: 'mdi-square'
          },
          {
            text: '100%',
            color: '#a50026',
            icon: 'mdi-square'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley',
  timeProperties: {
    defaultInterval: 24 * 60 * 60
  }
} as LayerRaw
